import React from "react";
import { AddForm } from "../../../components/article/add-form.js";
import Layout from "../../../components/layout/layout.js";

function ArticleAddPage({ component, ...rest }) {
  return <Layout Component={AddForm} {...rest} controlsDisabled={true} />;
}

export default ArticleAddPage;
